<app-dashboard-sidemenu></app-dashboard-sidemenu>

<!-- Start Main Content Wrapper Area -->
<div class="main-content d-flex flex-column">

    <app-dashboard-navbar></app-dashboard-navbar>
    <div class="spinner-overlay" *ngIf="isLoading">
        <div class="spinner"></div>
      </div>

    <!-- Breadcrumb Area -->
    <div class="breadcrumb-area" *ngFor="let Content of breadcrumb;">
        <h1>{{Content.title}}</h1>
        <ol class="breadcrumb">
            <li class="item"><a routerLink="/">Home</a></li>
            <li class="item"><a routerLink="dashboard">{{Content.subTitle}}</a></li>
            <li class="item">{{Content.title}}</li>
        </ol>
    </div>
    <!-- End Breadcrumb Area -->

    <!-- Start -->
    <div class="add-listings-box">
        <h3>Basic Informations</h3>
    
        <div class="row">
            <!-- <div class="col-lg-6 col-md-6">
                <div class="form-group">
                    <label><i class='bx bx-briefcase-alt'></i> Author</label>
                    <input type="text" class="form-control" placeholder="Author Name" [(ngModel)]="announcementDetails.AUTHOR_NAME">
                </div>
            </div> -->
            <div class="col-lg-6 col-md-6">
                <div class="form-group">
                    <label><i class='bx bx-briefcase-alt'></i> Announcement title</label>
                    <input type="text" class="form-control" placeholder="Enter Blog title" [(ngModel)]="announcementDetails.ANNOUNCEMENT_TITLE">
                </div>
            </div>
            <div class="col-lg-6 col-md-6">
                <div class="form-group">
                    <label><i class='bx bx-menu-alt-left'></i> From Date</label>
                    <input type="date" class="form-control" 
                    [(ngModel)]="announcementDetails.FROM_DATE"
                    placeholder="">
                </div>
            </div>
            <div class="col-lg-6 col-md-6">
                <div class="form-group">
                    <label><i class='bx bx-menu-alt-left'></i> To Date</label>
                    <input type="date" class="form-control"
                    [(ngModel)]="announcementDetails.TO_DATE"
                    placeholder="">
                </div>
            </div>
        </div>
    </div>

    
    <!-- <div class="add-listings-box">
        <h3>Feature Image</h3>
    
        <div class="file-upload-box">
            <input type="file" name="" id="">
            <form action="/file-upload" class="dropzone"></form>
        </div>
    </div> -->

    <div class="add-listings-box">
        <h3>Details</h3>
    
        <div class="row">
            <div class="col-lg-12 col-md-12">
                <div class="form-group">
                    <label><i class='bx bx-text'></i> Description:</label>
                    <textarea cols="30" rows="7" class="form-control" placeholder="Details..." [(ngModel)]="announcementDetails.ANNOUNCEMENT_DETAILS"></textarea>
                </div>
            </div>
        </div>
    </div>
            
    <div class="add-listings-btn">
        <button type="submit" (click)="addUpdateBlogBusiness()">Submit Announcement</button>
    </div>
    <!-- End -->

    <div class="flex-grow-1"></div>
 




</div>
<!-- End Main Content Wrapper Area -->